import React from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Link, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  getDatabase,
  ref,
  get,
  update,
  serverTimestamp,
} from "firebase/database";
import { sendAcceptOfferMessageAfterPayment } from "./utils/sendAcceptOfferUtils";
// import { removeAbandonedBooking } from "./utils/bookingUtils";
import {
  getBookingByID,
  sendEmail,
  sendSMS,
  updateBookingStatus,
  checkCoupon,
  getInquiryDataById,
  getPlatformPercentages,
  getCurrentUserDetails,
  getUserByID,
  BookingFormEmailBody,
  getOwnerMeta,
  getUserIdByRefferralCode,
  getListingByID,
} from "./utils";
import dayjs from "dayjs";
import { useAuth } from "../contexts/AuthContext";
import TextField from "@mui/material/TextField";
import { Alert, Checkbox, FormControlLabel } from "@mui/material";
import { Col, Row, Button, Modal } from "react-bootstrap";
import { ThreeDots } from "react-loader-spinner";

const PaymentForm = ({ amount }) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL; // Fetch the base URL from .env
  const stripe = useStripe();
  const elements = useElements();
  const navigate = useNavigate(); // Initialize useNavigate
  const auth = useAuth();

  const [storedBookingId, setBookingId] = useState("");
  const [storedPaymentId, setPaymentId] = useState("");
  const [bookingData, setBookingData] = useState("");
  const [acknowledgement2, setAcknowledgement2] = useState(false);
  const [offer, setOfferData] = useState("");
  const [inquiryData, setInquiryData] = useState([]);

  const [totalTax, setTotalTax] = useState(0);
  const [adminTax, setAdminTax] = useState(0);
  const [amountTotal, setAmountTotal] = useState(0);
  const [loading, setLoading] = useState(false);
  const [showPaymentModal, setShowPaymentModal] = useState(false);
  const [coupon, setCouponCode] = useState("");

  // Function to cancel booking when user leaves without payment
  const handleCancelBooking = async (bookingId) => {
    console.log("Starting handleCancelBooking for booking ID:", bookingId);
    try {
      console.log(`Canceling booking ${bookingId} due to abandoned payment`);
      const database = getDatabase();

      // Get booking data
      const bookingRef = ref(database, `bookings/${bookingId}`);
      const bookingSnapshot = await get(bookingRef);
      const bookingData = bookingSnapshot.val();

      if (!bookingData) {
        console.error(`No booking found with ID ${bookingId}`);
        return;
      }

      // Get payment data if it exists
      if (bookingData.paymentId) {
        const paymentRef = ref(database, `payments/${bookingData.paymentId}`);
        const paymentSnapshot = await get(paymentRef);
        const paymentData = paymentSnapshot.val();

        // If payment exists, update its status
        if (paymentData) {
          await update(paymentRef, {
            status: "cancelled",
            cancelledAt: new Date().toISOString(),
          });
        }

        // Check for pending payments
        const pendingPaymentRef = ref(
          database,
          `pendingPayments/${bookingData.paymentId}`
        );
        const pendingPaymentSnapshot = await get(pendingPaymentRef);

        if (pendingPaymentSnapshot.exists()) {
          await update(pendingPaymentRef, { status: "cancelled" });
        }
      }

      // Update booking status
      await updateBookingStatus(bookingId, "cancelled");

      // Update inquiry status if it exists
      if (bookingData.inquiryId) {
        const inquiryRef = ref(database, `inquiries/${bookingData.inquiryId}`);
        const inquirySnapshot = await get(inquiryRef);
        const inquiryData = inquirySnapshot.val();
        await update(inquiryRef, { status: "canceled" });

        // Update chat messages to reflect cancellation
        if (bookingData.owner && bookingData.renter) {
          // Determine chat IDs based on user IDs
          const [firstUserId, secondUserId] =
            bookingData.owner < bookingData.renter
              ? [bookingData.owner, bookingData.renter]
              : [bookingData.renter, bookingData.owner];

          const chatId1 = `${firstUserId}_${secondUserId}`;
          const chatId2 = `${secondUserId}_${firstUserId}`;

          // Create cancellation message
          const offerMessage = `This offer has been canceled due to abandoned payment.`;

          const messageData = {
            senderId: bookingData.owner,
            receiverId: bookingData.renter,
            message: offerMessage,
            timestamp: serverTimestamp(),
            listingId: bookingData.listingId,
            inquiryId: bookingData.inquiryId,
            status: "canceled",
            offerStatus: "Canceled",
            // Remove offer: 1 flag to prevent the View Offer button from appearing
          };

          console.log("Created message data for cancellation:", messageData);

          // Update chat messages
          const chatRef1 = ref(database, `chats/${chatId1}`);
          const chatRef2 = ref(database, `chats/${chatId2}`);

          const chatSnapshot1 = await get(chatRef1);
          const chatSnapshot2 = await get(chatRef2);

          if (chatSnapshot1.exists()) {
            // Update existing messages to mark offer as canceled
            const updatedMessages = [...chatSnapshot1.val().messages]?.map(
              (message) => {
                if (message?.inquiryId === bookingData.inquiryId) {
                  console.log("Updating message to canceled status:", message);
                  return {
                    ...message,
                    offerStatus: "Canceled",
                    status: "canceled",
                  };
                }
                return message;
              }
            );

            console.log("Updating chat with ID:", chatId1);
            console.log(
              "Number of messages before update:",
              updatedMessages.length
            );

            await update(chatRef1, {
              senderReadStatus: 1,
              receiverReadStatus: 0,
              lastSenderId: bookingData.owner,
              messages: [...updatedMessages, messageData],
            });

            console.log("Chat updated successfully");
          } else if (chatSnapshot2.exists()) {
            // Update existing messages to mark offer as canceled
            const updatedMessages = [...chatSnapshot2.val().messages]?.map(
              (message) => {
                if (message?.inquiryId === bookingData.inquiryId) {
                  console.log("Updating message to canceled status:", message);
                  return {
                    ...message,
                    offerStatus: "Canceled",
                    status: "canceled",
                  };
                }
                return message;
              }
            );

            console.log("Updating chat with ID:", chatId2);
            console.log(
              "Number of messages before update:",
              updatedMessages.length
            );

            await update(chatRef2, {
              senderReadStatus: 1,
              receiverReadStatus: 0,
              lastSenderId: bookingData.owner,
              messages: [...updatedMessages, messageData],
            });

            console.log("Chat updated successfully");
          }
        }
      }

      console.log(`Successfully canceled booking ${bookingId}`);
      console.log("Booking cancellation complete - all updates finished");
    } catch (error) {
      console.error("Error canceling booking:", error);
    }
  };

  const [discount, setDiscount] = useState(0);
  const [totalOwnerBookings, setTotalOwnerBookings] = useState(0);

  const queryParameters = new URLSearchParams(window.location.search);
  const bookingId = queryParameters.get("bookingId");
  const [platformPercentages, setPlatformPercentages] = useState({});

  const handleAcknowledgement = (acknowledgementName) => {
    if (acknowledgementName === "acknowledgement1") {
    } else if (acknowledgementName === "acknowledgement2") {
      setAcknowledgement2((prev) => !prev);
    }
  };

  const [listingData, setListingData] = useState([]);
  // When component mounts, mark the booking as in-progress to prevent automatic deletion
  useEffect(() => {
    const markBookingInProgress = async () => {
      if (bookingId) {
        try {
          // First check if this booking is already paid
          const completedPayments = JSON.parse(
            localStorage.getItem("completedPayments") || "[]"
          );
          if (completedPayments.includes(bookingId)) {
            console.log(`Payment already completed for booking ${bookingId}`);
            return; // Already paid, no need to mark as in-progress
          }

          // Mark the booking as in-progress in the database
          const database = getDatabase();
          const bookingRef = ref(database, `bookings/${bookingId}`);
          const bookingSnapshot = await get(bookingRef);

          if (bookingSnapshot.exists()) {
            const bookingData = bookingSnapshot.val();
            // Only update if it's not already paid
            if (bookingData.status !== "paid") {
              await update(bookingRef, { paymentInProgress: true });
              console.log(`Marked booking ${bookingId} as payment in progress`);

              // Store the booking ID in localStorage to clean up later if needed
              localStorage.setItem("currentPaymentBookingId", bookingId);
            }
          }
        } catch (error) {
          console.error("Error marking booking as in-progress:", error);
        }
      }
    };

    markBookingInProgress();

    // Cleanup function - only remove the in-progress flag if payment wasn't completed
    return () => {
      const cleanupBooking = async () => {
        const currentBookingId = localStorage.getItem(
          "currentPaymentBookingId"
        );
        if (currentBookingId && currentBookingId === bookingId) {
          // Check if this booking was paid
          const completedPayments = JSON.parse(
            localStorage.getItem("completedPayments") || "[]"
          );
          if (!completedPayments.includes(bookingId)) {
            console.log(
              `User left payment page without completing payment for booking ${bookingId}`
            );
            await handleCancelBooking(bookingId);
          }
          localStorage.removeItem("currentPaymentBookingId");
        }
      };

      cleanupBooking();
    };
  }, [bookingId]);

  useEffect(() => {
    // Open the payment modal when component mounts
    setShowPaymentModal(true);

    const fetchDetails = async () => {
      try {
        const bookingDetails = await getBookingByID(bookingId);
        if (!bookingDetails) {
          // No need to proceed if bookingDetails is null
          return;
        }

        const listingDetails = await getListingByID(bookingDetails.listingId);
        setListingData(listingDetails);

        const inquiryDetails = await getInquiryDataById(
          bookingDetails["inquiryId"]
        );
        const ownerMetaDetails = await getOwnerMeta(bookingDetails.owner);

        if (ownerMetaDetails?.totalPaidBookings != null) {
          setTotalOwnerBookings(ownerMetaDetails.totalPaidBookings); // Corrected function name
        } else {
          setTotalOwnerBookings(0);
        }

        // Logging the updated value of totalOwnerBookings here

        setInquiryData(inquiryDetails);
        const offerDetails = inquiryDetails["offerData"];

        const platformFeesData = await getPlatformPercentages();

        let platformData = {
          salesTax: parseFloat(platformFeesData.defaultSalesTax),
        };
        platformData.adminCut = parseFloat(platformFeesData.defaultAdminCut);
        // if(listingDetails.boatType === 'Bass Boat') {
        //   platformData.adminCut = parseFloat(platformFeesData.defaultAdminCut);
        //   console.log('bass boat');
        // } else {
        //   platformData.adminCut = parseFloat(platformFeesData.defaultOtherBoatTypeAdminCut);
        //   console.log('other type');
        // }

        setPlatformPercentages(platformData);
        setOfferData(offerDetails);
        setBookingId(bookingId);
        setBookingData(bookingDetails);
        setPaymentId(bookingDetails.paymentId);
        console.log(platformPercentages, "test test");
      } catch (error) {
        console.error("Error fetching listing details:", error);
      }
    };

    fetchDetails();
  }, [bookingId]);

  const verifyDiscount = async (code) => {
    const coupon = await checkCoupon(code);
    if (coupon != null) {
      setDiscount(parseInt(coupon[0].discount * 100));
    }
  };

  const [error, setError] = useState("");

  // Updated handleSubmit function with new payment rules
  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError("");
    if (!acknowledgement2) {
      setError("You must acknowledge to continue.");
      setLoading(false);
      return;
    }

    if (!stripe || !elements) {
      return;
    }

    // Create token from card element
    const { token, error } = await stripe.createToken(
      elements.getElement(CardElement)
    );

    if (error) {
      console.error(error);
      setError(
        error.message ||
          "There was an error processing your card. Please try again."
      );
      setLoading(false);
      return;
    } else {
      // Calculate tax and fees
      const taxTotal = platformPercentages.salesTax * amount;
      setTotalTax(taxTotal);
      const taxAdmin = platformPercentages.adminCut * taxTotal;
      setAdminTax(taxAdmin);

      // Your existing fee calculation code
      let cutAdmin = 0;
      let refferalAmount = 0;
      let adminFirstTimeCut = 0;
      let cutPercentage = 0.1;
      const ownerData = await getUserByID(bookingData.owner);
      const referId = await getUserIdByRefferralCode(ownerData.refferalCode);

      // FEATURE 2: First-Time Booking Rule
      if (totalOwnerBookings === 0) {
        if (amount < 20000) {
          // For bookings under $200, take 50% of the booking amount
          cutAdmin = 0.05 * amount + 0.5 * amount;
          // No fixed admin fee for bookings under $200
          adminFirstTimeCut = 0;
        } else if (referId !== null) {
          // Original logic for bookings $200 and above with referral
          if (differenceInDays > 14) {
            cutAdmin =
              0.05 * amount + platformPercentages.adminCut * 20000 + 4000;
          } else {
            cutAdmin =
              0.05 * amount + platformPercentages.adminCut * amount + 4000;
          }
          adminFirstTimeCut = 4000;

          // Your existing referral logic
          const database = getDatabase();
          const referPayments = ref(database, `ownerMeta/${referId}`);

          const previousReferPaymentsSnapshot = await get(referPayments);

          if (previousReferPaymentsSnapshot.exists()) {
            const referPaymentData = previousReferPaymentsSnapshot.val();

            const previousCurrentAmount =
              referPaymentData.payments.currentAmount;
            const previousTotalAmount = referPaymentData.payments.totalAmount;
            const referPaymentObject = {
              currentAmount: previousCurrentAmount + 3000,
              totalAmount: previousTotalAmount + 3000,
            };
            await update(referPayments, { payments: referPaymentObject });
            refferalAmount = 3000;
          }
        } else {
          // Original logic for bookings $200 and above without referral
          if (differenceInDays > 14) {
            cutAdmin =
              0.05 * amount + platformPercentages.adminCut * 20000 + 10000;
          } else {
            cutAdmin =
              0.05 * amount + platformPercentages.adminCut * amount + 10000;
          }
          adminFirstTimeCut = 10000;
        }
      } else {
        // Non-first time owner logic
        if (differenceInDays > 14) {
          cutAdmin = 0.05 * amount + 0.1 * 20000;
        } else {
          cutAdmin = 0.05 * amount + 0.1 * amount;
        }
      }

      const finalAmount =
        parseInt(amount + taxTotal) +
        0.05 * amount -
        (discount > 0 ? discount : 0);
      setAmountTotal(finalAmount);
      const renterData = await getCurrentUserDetails();

      try {
        // FEATURE 1: Upfront Payment Rule
        // Determine if we should charge the full amount upfront
        const isLowValueFutureBooking = amount < 20000 && differenceInDays > 14;

        // Choose the appropriate endpoint based on booking distance
        let endpoint;
        if (differenceInDays <= 14) {
          endpoint = `${BASE_URL}/capture-payment`;
        } else {
          endpoint = `${BASE_URL}/capture-payment-advance`;
        }

        const response = await fetch(endpoint, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
            "Access-Control-Allow-Origin": `${BASE_URL}`,
          },
          mode: "cors",
          body: JSON.stringify({
            tokenId: token.id,
            amount: finalAmount,
            daysDifference: differenceInDays,
            paymentId: storedPaymentId,
            renter: bookingData.renter,
            owner: bookingData.owner,
            email: renterData.email,
            title: bookingData.listingTitle,
            isLowValueFutureBooking, // Flag for low-value future bookings
          }),
        });

        const result = await response.json();
        console.log("result: ", result);

        if (result.success) {
          // Update the booking status to "Waiver Pending"
          await updateBookingStatus(storedBookingId, "Waiver Pending");

          const database = getDatabase();
          const paymentRef = ref(database, `payments/${storedPaymentId}`);

          let dbOwnerAmount = 0;

          // Calculate owner amount based on booking type
          if (differenceInDays > 14 && !isLowValueFutureBooking) {
            // Standard future booking with deposit
            if (totalOwnerBookings > 0) {
              dbOwnerAmount = 20000 - cutAdmin + 0.05 * amount;
            }
          } else {
            // Near-term booking OR low-value future booking (full payment)
            dbOwnerAmount = amount - cutAdmin + 0.05 * amount;
          }

          try {
            // Store payment details
            let paymentData = {
              totalAmount: finalAmount,
              paidAmount:
                differenceInDays > 14 && !isLowValueFutureBooking
                  ? 20000
                  : finalAmount,
              ownerAmount: dbOwnerAmount,
              discount: discount > 0 ? discount : 0,
              cutPercentage,
              totalTax: taxTotal,
              adminCut: cutAdmin,
              adminTax: taxAdmin,
              dateTime: dayjs().format("dddd, MMMM D, YYYY HH:mm:ss"),
              transactionId: result.chargeId || result.paymentIntent?.id || "0",
              userId: auth.currentUser.uid,
              bookingId: storedBookingId,
              owner: bookingData.owner,
              status: "paid", // Payment status
              payout_status: "pending", // Payout status
            };

            // Additional fields for advance bookings with partial payment
            if (differenceInDays > 14 && !isLowValueFutureBooking) {
              paymentData.advanceBooking = 1;
              paymentData.advancePaid = 20000;
              paymentData.remainingAmount = finalAmount - 20000;
            } else if (isLowValueFutureBooking) {
              // For low-value future bookings, mark as advance booking but with full payment
              paymentData.advanceBooking = 1;
              paymentData.advancePaid = finalAmount;
              paymentData.remainingAmount = 0;
              paymentData.isLowValueFullPayment = true;
            }

            if (totalOwnerBookings === 0) {
              paymentData.firstRentalPayment = 1;

              // Add a flag for the special first-time low-value case
              if (amount < 20000) {
                paymentData.firstTimeSpecialRate = true;
                paymentData.specialAdminRate = 0.5; // 50% admin fee
              }
            }

            if (refferalAmount > 0) {
              paymentData.referrer = referId;
              paymentData.referAmount = refferalAmount;
              paymentData.adminFirstTimeCut = adminFirstTimeCut;
            }

            await update(paymentRef, paymentData);

            // Handle owner payment records
            // const ownerMetaPayments = ref(
            //   database,
            //   `ownerMeta/${bookingData.owner}`
            // );
            // const previousOwnerPaymentsSnapshot = await get(ownerMetaPayments);

            // if (previousOwnerPaymentsSnapshot.exists()) {
            //   const previousOwnerPayments = previousOwnerPaymentsSnapshot.val();
            //   const previousCurrentAmount =
            //     previousOwnerPayments.payments.currentAmount;
            //   const previousTotalAmount =
            //     previousOwnerPayments.payments.totalAmount;

            //   const ownerPayments = {
            //     currentAmount: previousCurrentAmount + dbOwnerAmount,
            //     totalAmount: previousTotalAmount + dbOwnerAmount,
            //   };

            //   console.log(ownerPayments);

            //   if (previousOwnerPayments.previousTotalAmount) {
            //     const updatedTotalPaidBookings =
            //       parseInt(previousOwnerPayments.previousTotalAmount) + 1;
            //     await update(ownerMetaPayments, {
            //       payments: ownerPayments,
            //       totalPaidBookings: updatedTotalPaidBookings,
            //     });
            //   } else {
            //     await update(ownerMetaPayments, {
            //       payments: ownerPayments,
            //       totalPaidBookings: 1,
            //     });
            //   }
            // } else {
            //   const ownerPayments = {
            //     currentAmount: dbOwnerAmount,
            //     totalAmount: dbOwnerAmount,
            //   };
            //   console.log(ownerPayments);
            //   await update(ownerMetaPayments, {
            //     payments: ownerPayments,
            //     totalPaidBookings: 1,
            //   });
            // }

            // Send notifications
            const subjectEmail = "Booking Request Submitted";
            const renterName = renterData.firstName + " " + renterData.lastName;
            const emailBody = await BookingFormEmailBody(
              renterName,
              bookingData.listingTitle,
              "has been paid."
            );
            sendEmail(renterData.email, subjectEmail, emailBody);

            const renterSmsBody = `Hello ${renterName}, Payment for ${bookingData.listingTitle} received. Thank you!`;
            const renterSmsResponse = sendSMS(renterData.phone, renterSmsBody);
            console.log(renterSmsResponse);

            const ownerName = ownerData.firstName + " " + ownerData.lastName;
            const subjectOwnerEmail = "New Booking Request";
            const emailOwnerBody = await BookingFormEmailBody(
              ownerName,
              bookingData.listingTitle,
              "received a new booking payment."
            );
            sendEmail(ownerData.email, subjectOwnerEmail, emailOwnerBody);

            const ownerSmsBody = `Hello ${ownerName}, payment for ${bookingData.listingTitle} received from ${renterName}.`;
            const ownerSmsResponse = sendSMS(ownerData.phone, ownerSmsBody);
            console.log(ownerSmsResponse);

            // Check if this payment is for an accepted offer and send the accept offer message
            try {
              const acceptOfferDataString =
                localStorage.getItem("acceptOfferData");
              if (acceptOfferDataString) {
                await sendAcceptOfferMessageAfterPayment();
                console.log("Accept offer message sent after payment");
              }
            } catch (error) {
              console.error("Error sending accept offer message:", error);
              // Continue with navigation even if there's an error with the accept offer message
            }

            // Store completed payment in localStorage to persist across page refreshes/navigations
            const completedPayments = JSON.parse(
              localStorage.getItem("completedPayments") || "[]"
            );
            if (!completedPayments.includes(storedBookingId)) {
              completedPayments.push(storedBookingId);
              localStorage.setItem(
                "completedPayments",
                JSON.stringify(completedPayments)
              );
            }

            // Remove the in-progress flag since payment is complete
            localStorage.removeItem("currentPaymentBookingId");

            navigate("/dashboard/thank-you");
            setLoading(false);
          } catch (error) {
            console.log("Error saving data: ", error);
            setLoading(false);
          }
        } else if (result.error) {
          console.error("Payment failed:", result.error);
          setError(result.error);
          setLoading(false);
        } else {
          console.error("Payment failed:");
          setError("Payment failed: ");
          setLoading(false);
        }
      } catch (error) {
        console.error("Error capturing payment:", error);
        setError(error);
        setLoading(false);
      }
    }
  };

  const holdPayment = async () => {
    if (!stripe || !elements) {
      return;
    }

    const { paymentMethod, error } = await stripe.createPaymentMethod({
      type: "card",
      card: elements.getElement(CardElement) ?? {},
    });

    if (error) {
      console.error(error);
    } else {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_BASE_URL}/payment-hold`,
          {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
            },
            body: JSON.stringify({
              amount: 80000,
              payment_method: paymentMethod.id,
            }),
          }
        );

        const result = await response.json();
        console.log("result: ", result);

        const database = getDatabase();
        const paymentRef = ref(database, `payments/${storedPaymentId}`);

        try {
          // Retrieve existing data
          const currentData = (await get(paymentRef)).val() || {};

          const paymentHeld = {
            id: result.paymentIntent.id,
            amount: result.paymentIntent.amount,
            status: "pending",
          };

          // Merge existing data with new data
          const mergedData = {
            ...currentData,
            paymentHeld: paymentHeld,
          };

          // Update the database with merged data
          await update(paymentRef, mergedData);
        } catch (error) {
          console.log("Error saving data: ", error.message);
        }
      } catch (error) {
        console.error("Error capturing payment:", error);
      }
    }
  };

  const options = {
    month: "long",
    day: "numeric",
    year: "numeric",
    hour: "numeric",
    minute: "numeric",
    hour12: true,
  };
  function formatDateTime(dateTimeString) {
    const formattedDateTimeNew = new Date(dateTimeString);
    return formattedDateTimeNew;
  }

  const offerPriceAsNumber = Number(offer.offerPrice);

  const offeredDate = formatDateTime(
    `${offer.offeredDate} ${offer.offeredTime}`
  );
  const amountDisplay =
    discount > 0
      ? parseFloat(offerPriceAsNumber) +
        0.05 * offerPriceAsNumber +
        parseFloat(platformPercentages.salesTax) *
          parseFloat(offerPriceAsNumber) -
        parseFloat(discount / 100).toLocaleString()
      : (
          parseFloat(offerPriceAsNumber) +
          0.05 * offerPriceAsNumber +
          parseFloat(platformPercentages.salesTax) *
            parseFloat(offerPriceAsNumber)
        ).toLocaleString();
  const amountInteger =
    discount > 0
      ? parseFloat(offerPriceAsNumber) +
        parseFloat(platformPercentages.salesTax) *
          parseFloat(offerPriceAsNumber) -
        parseFloat(discount / 100).toLocaleString()
      : parseFloat(offerPriceAsNumber) +
        parseFloat(platformPercentages.salesTax) *
          parseFloat(offerPriceAsNumber);
  // Convert the date string to a Date object

  // Get the current date
  var currentDate = new Date();

  // Calculate the difference in milliseconds
  var difference = offeredDate - currentDate;
  // Convert milliseconds to days
  var differenceInDays = difference / (1000 * 60 * 60 * 24);

  // Check if offerPriceAsNumber is a valid number
  const formattedOfferPrice = isNaN(offerPriceAsNumber)
    ? "Invalid Number"
    : offerPriceAsNumber.toLocaleString();

  const handleCloseModal = () => {
    setShowPaymentModal(false);
  };

  return (
    <>
      {/* Payment confirmation modal */}
      <Modal show={showPaymentModal} onHide={handleCloseModal} centered>
        <Modal.Body>
          <p>
            Please proceed with the payment, the booking is not confirmed until
            payment has been completed
          </p>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleCloseModal}>
            Confirm
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="row">
        <div className="col">
          <div className="page-description d-flex justify-content-between">
            <h1>{bookingData.listingTitle}</h1>
          </div>
        </div>
      </div>

      <Row className="card p-4">
        <div className="mb-4">
          <div className="mt-2">
            <div className="row">
              <div className="col-sm-4">
                <p className="mb-0">Amount</p>
              </div>
              <div className="col-sm-8">
                {differenceInDays <= 14 ||
                (differenceInDays > 14 && offerPriceAsNumber < 200) ? (
                  // Non-advance booking OR low-value future booking: full payment upfront
                  <h3 className="text-muted mb-0 text-dark">
                    ${amountDisplay}{" "}
                    <span
                      className="text-muted mb-0"
                      style={{ fontSize: "14px" }}
                    >
                      (includes 5% platform fees and 8.25% tax)
                    </span>
                  </h3>
                ) : (
                  // Advance booking with deposit
                  <>
                    <h3 className="text-muted mb-0 text-dark">
                      $200{" "}
                      <span
                        className="text-muted mb-0"
                        style={{ fontSize: "14px" }}
                      >
                        deposit. Remaining ${(amountInteger - 200).toFixed(2)}{" "}
                        (includes 5% platform fees and 8.25% tax) will be
                        charged 48 hours prior to start date.
                      </span>
                    </h3>
                  </>
                )}
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-sm-4">
                <p className="mb-0">Offered Date Time</p>
              </div>
              <div className="col-sm-8">
                <p className="text-muted mb-0">
                  {offeredDate.toLocaleString("en-US", options)}
                </p>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-sm-4">
                <p className="mb-0">Duration</p>
              </div>
              <div className="col-sm-8">
                <p className="text-muted mb-0">{offer.duration}</p>
              </div>
            </div>
            <hr />
            <div className="row">
              <div className="col-sm-4">
                <p className="mb-0">Arriving Date Time</p>
              </div>
              <div className="col-sm-8">
                <p className="text-muted mb-0">{offer.arivingDateTime}</p>
              </div>
            </div>
            {/* First-time owner booking notice */}
            {totalOwnerBookings === 0 && offerPriceAsNumber < 200 && (
              <>
                <hr />
                <div className="row">
                  <div className="col-sm-4">
                    <p className="mb-0">First-Time Owner</p>
                  </div>
                  <div className="col-sm-8">
                    <p className="text-muted mb-0">
                      <span className="text-info">
                        Note: Special pricing applies for this owner's first
                        booking.
                      </span>
                    </p>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <Col>
          <form onSubmit={handleSubmit} className="mt-4">
            <div style={{ marginBottom: "20px" }}>
              <Row>
                <Col>
                  <TextField
                    id="standard-basic"
                    value={coupon}
                    onChange={(e) => setCouponCode(e.target.value)}
                    label="Coupon Code"
                    variant="standard"
                  />
                  <Button
                    variant="primary"
                    onClick={() => verifyDiscount(coupon)}
                    className="btn btn-primary m-1"
                  >
                    Apply
                  </Button>
                  {discount > 0 ? (
                    <Alert className="mt-3" severity="success">
                      -${discount / 100} discount has been applied.
                    </Alert>
                  ) : (
                    ""
                  )}
                </Col>
              </Row>
              <Row className="mt-3">
                <Col>
                  <CardElement
                    className="form-control"
                    options={{
                      style: {
                        base: {
                          fontSize: "16px",
                          color: "#424770",
                          "::placeholder": {
                            color: "#aab7c4",
                          },
                        },
                        invalid: {
                          color: "#9e2146",
                        },
                      },
                    }}
                  />
                  {error && (
                    <Alert className="mt-3" severity="error">
                      {`${error}` ?? ""}
                    </Alert>
                  )}
                </Col>
              </Row>
              <Row className="mt-4">
                <Col>
                  <div className="d-flex mt-1 additional-box">
                    <FormControlLabel
                      style={{ alignItems: "flex-start" }}
                      required
                      control={<Checkbox checked={acknowledgement2} />}
                      onChange={() => setAcknowledgement2(!acknowledgement2)}
                    />
                    <div>
                      <p style={{ fontWeight: "500", lineHeight: "28px" }}>
                        Please check this box to acknowledge that you have read
                        and agreed to the cancellation policy - refer to the{" "}
                        <Link to="/">website</Link> for additional cancellation
                        information <span style={{ color: "red" }}>*</span>
                      </p>
                    </div>
                  </div>
                </Col>
              </Row>
            </div>
            <button
              variant="primary"
              type="submit"
              className="btn btn-primary m-1"
            >
              {loading ? (
                <ThreeDots
                  visible={true}
                  height="22"
                  width="22"
                  color="#fff"
                  radius="20"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClass=""
                />
              ) : (
                "Pay"
              )}
            </button>
          </form>
        </Col>
      </Row>
    </>
  );
};

export default PaymentForm;
